export const rav_hear_about_us = [
    {code: 'e2fwebsite', label : 'e2f website'},
    {code: 'e2fLinkedIn', label : 'e2f LinkedIn'},
    {code: 'e2fFacebook', label : 'e2f Facebook'},
    {code: 'Facebook', label : 'Facebook'},
    {code: 'Instagram', label : 'Instagram'},
    {code: 'TikTok', label : 'TikTok'},
    {code: 'FlexJobs', label : 'FlexJobs'},
    {code: 'Indeed', label : 'Indeed'},
    {code: 'OtherJobboard', label : 'Other Job board (if yes, which one)'},
    {code: 'Others', label : 'Others (if yes, specify)'},
]